export default __webpack_public_path__ + "static/media/5_hubspot.ea23a4f2.svg";